



































































































































































































































































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';
import { UserRegisterPageInfo } from '@/interfaces';

class State {
  userid: number;
  empno: string;
  name: string;
  uid: string;
  telNo: string;
  email: string;
  photo: string | ArrayBuffer | null;
  accessZoneCode: number;
  companyCode: I.CodeData;
  deptCodeA: I.CodeData;
  deptCodeB: I.CodeData;
  dutyCodeA: I.CodeData;
  userType: string;
  userStatus: string;
  isAntipass: boolean;
  isAdmin: boolean;
  isEscort: boolean;
  periodFrom: Date;
  periodTo: Date;
  timeFrom: string;
  timeTo: string;
  listDoor: I.DoorAuthSendData[];
  listGroup: I.DoorAuthSendData[];
  constructor() {
    this.userid = -1;
    this.empno = '';
    this.name = '';
    this.uid = '';
    this.telNo = '';
    this.email = '';
    this.photo = '';
    this.accessZoneCode = 0;
    this.companyCode = { code: '', name: '' };
    this.deptCodeA = { code: '', name: '' };
    this.deptCodeB = { code: '', name: '' };
    this.dutyCodeA = { code: '', name: '' };
    this.userStatus = '1';
    this.userType = '1';
    this.isAntipass = false;
    this.isAdmin = false;
    this.isEscort = false;
    this.periodFrom = new Date();
    this.periodTo = new Date(2050, 11, 31, 23, 59, 0);
    this.timeFrom = '';
    this.timeTo = '';
    this.listDoor = [];
    this.listGroup = [];
  }
}

class DialogState<T extends I.DoorAuthSendData> {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: T[];
  headers: unknown[];
  items: T[];
  zoneCode: number;
  callback: Function;

  onAdd(list: T[]) {
    list.forEach(item => {
      this.selected.push(item);
    });
  }

  onRemove(list: T[]) {
    list.forEach(item => {
      const find = this.selected.find(x => x.code === item.code);
      if (find) {
        const idx = this.selected.indexOf(find);
        if (idx > -1) {
          this.selected.splice(idx, 1);
        }
      }
    });
  }

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.zoneCode = 0;
    this.callback = async () => {};
  }
}

enum ECodeType {
  ECompanyCode,
  EDeptCodeA,
  EDeptCodeB,
  EDutyCodeA
}

class CodeDialogState {
  show: boolean;
  title: string;
  items: I.CodeData[];
  selected: unknown;
  search: string;
  headers: unknown[];
  codeType: ECodeType;
  callback: Function;

  constructor() {
    this.show = false;
    this.title = '';
    this.items = [];
    this.search = '';
    this.headers = [];
    this.callback = async () => {};
    this.codeType = ECodeType.ECompanyCode;
  }
}

@Component
export default class UserRegister extends Mixins(AxPage) {
  state = new State();
  pageInfo?: UserRegisterPageInfo;
  listUserStatus: I.CodeData[] = [];
  listUserType: I.CodeData[] = [];
  listDoor: I.DoorData[] = [];
  listGroup: I.GroupSingle[] = [];
  dialogState = new DialogState();
  codeDialogState = new CodeDialogState();
  message = '';
  tabCard = 0;
  tabZone = 0;

  get periodFrom() {
    return this.formatTime(this.state.periodFrom.toISOString(), 'YYYY-MM-DD');
  }

  set periodFrom(date: string) {
    this.state.periodFrom = new Date(date);
  }

  get periodTo() {
    return this.formatTime(this.state.periodTo.toISOString(), 'YYYY-MM-DD');
  }

  set periodTo(date: string) {
    this.state.periodTo = new Date(date);
  }

  @Ref()
  fileUpload!: HTMLInputElement;

  TabZoneChange(value: number) {
    const list = this.getZoneList();
    if (list) {
      this.state.accessZoneCode = list[value].code;
    }
  }

  ClickOpenGroupPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllGroup = this.listGroup.filter(x => x.zoneCode === this.state.accessZoneCode);
    console.log('page', this.listGroup);
    console.log('group', listAllGroup);
    console.log('zonecode', this.state.accessZoneCode);
    if (!listAllGroup) return;

    const listGroup = this.state.listGroup.filter(x => x.zoneCode === this.state.accessZoneCode);

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 그룹 선택',
      param: {
        items: listAllGroup,
        selected: listGroup,
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorAuthSendData[];
          const remain = this.state.listGroup.filter(x => x.zoneCode !== this.state.accessZoneCode);

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listGroup = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenDoorPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    console.log('zone코드', this.state.accessZoneCode);
    const listAllDoor = this.listDoor.filter(x => x.zoneCode === this.state.accessZoneCode);
    if (!listAllDoor) return;

    const listDoor = this.state.listDoor.filter(x => x.zoneCode === this.state.accessZoneCode);

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: listDoor,
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorAuthSendData[];
          const remain = this.state.listDoor.filter(x => x.zoneCode !== this.state.accessZoneCode);

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listDoor = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  onAdd(list: I.DoorAuthSendData[]) {
    this.dialogState.onAdd(list);
  }

  onRemove(list: I.DoorAuthSendData[]) {
    this.dialogState.onRemove(list);
  }

  ClickDoorSave() {
    this.dialogState.show = false;
    this.state.listDoor = [];
    this.dialogState.selected.forEach(item => {
      this.state.listDoor.push({
        code: item.code,
        name: item.name,
        zoneCode: item.zoneCode,
        zoneName: item.zoneName,
        scheduleCode: 0
      });
    });
  }

  ClickGroupSave() {
    this.dialogState.show = false;
    this.state.listGroup = [];
    this.dialogState.selected.forEach(item => {
      this.state.listGroup.push({
        code: item.code,
        name: item.name,
        zoneCode: item.zoneCode,
        zoneName: item.zoneName,
        scheduleCode: 0
      });
    });
  }

  onDialogRowClicked(item: never) {
    this.codeDialogState.selected = item;
  }

  upload() {
    this.fileUpload.click();
  }
  async prepare() {
    const baseData = await this.getBaseData();
    if (baseData) {
      this.pageInfo = baseData;
      this.listUserStatus = baseData.listUserStatus;
      this.listUserType = baseData.listUserType;
      console.log('page', this.pageInfo);
      this.listGroup = this.pageInfo?.listGroup;
      this.listDoor = this.pageInfo?.listDoor;
      if (this.pageInfo) {
        const list = this.getZoneList();
        if (list) {
          this.state.accessZoneCode = list[0].code;
        }
        // this.dialogState.items = this.pageInfo.listDoor;
        // this.pageInfo.listDoor.forEach(item => {
        //   this.dialogState.items.push({
        //     code: item.code,
        //     name: item.name,
        //     zoneCode: item.zoneCode,
        //     zoneName: item.zoneName
        //   });
        // });
      }
    }
  }

  async getBaseData() {
    const result = await this.API.call.user.getRegisterPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async closeDialog() {
    console.log('close dialog');
    this.codeDialogState.show = false;
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
      this.codeDialogState = new CodeDialogState();
      if (this.pageInfo) {
        // this.pageInfo.listDoor.forEach(item => {
        //   this.dialogState.items.push({
        //     code: item.code,
        //     name: item.name,
        //     zoneCode: item.zoneCode,
        //     zoneName: item.zoneName
        //   });
        // });
      }
    }, 100);
  }
  CodeSelect() {
    if (this.codeDialogState.codeType === ECodeType.ECompanyCode) {
      this.state.companyCode = (this.codeDialogState.selected as I.CodeData[])[0];
    } else if (this.codeDialogState.codeType === ECodeType.EDeptCodeA) {
      this.state.deptCodeA = (this.codeDialogState.selected as I.CodeData[])[0];
    } else if (this.codeDialogState.codeType === ECodeType.EDeptCodeB) {
      this.state.deptCodeB = (this.codeDialogState.selected as I.CodeData[])[0];
    } else if (this.codeDialogState.codeType === ECodeType.EDutyCodeA) {
      this.state.dutyCodeA = (this.codeDialogState.selected as I.CodeData[])[0];
    }
    this.closeDialog();
  }

  showCompanySelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '회사 검색',
      param: {
        items: this.pageInfo.listCompanyCode,
        selected: [this.state.companyCode],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.companyCode = selected[0];
          } else {
            this.state.companyCode = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDeptCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '사업장 검색',
      param: {
        items: this.pageInfo.listDeptCodeA,
        selected: [this.state.deptCodeA],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.deptCodeA = selected[0];
          } else {
            this.state.deptCodeA = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDeptCodeBSelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '부서 검색',
      param: {
        items: this.pageInfo.listDeptCodeB,
        selected: [this.state.deptCodeB],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.deptCodeB = selected[0];
          } else {
            this.state.deptCodeB = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDutyCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '직급 검색',
      param: {
        items: this.pageInfo.listDutyCodeA,
        selected: [this.state.dutyCodeA],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.dutyCodeA = selected[0];
          } else {
            this.state.dutyCodeA = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }
  getBase64(file: File) {
    const state = this.state;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      if (reader.result) state.photo = reader.result;
    };
    reader.onerror = function(error) {
      console.log('Error: ', error);
    };
  }

  OnFileChange() {
    if (this.fileUpload.files) this.getBase64(this.fileUpload.files[0]);
  }

  OnClear() {
    this.state = new State();
    if (this.pageInfo) {
      const list = this.getZoneList();
      if (list) {
        this.state.accessZoneCode = list[0].code;
      }
    }
  }

  OpenCodePopup(type: string) {
    if (type === 'companycode') {
      if (!this.pageInfo) return;

      this.showCodeSelectDialog({
        title: '사업장 검색',
        param: {
          items: this.pageInfo.listCompanyCode,
          selected: [this.state.companyCode],
          callback: async (selected: I.CodeData) => {
            this.state.companyCode = selected;
          }
        },
        single: true
      });
      return;
    }
    if (this.pageInfo == null) return;
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    this.codeDialogState.headers = headers;
    let list: I.CodeData[] = [];
    let title = '';
    let codeType: ECodeType = ECodeType.ECompanyCode;
    if (type === 'companycode') {
      list = this.pageInfo.listCompanyCode;
      title = '회사 검색';
      codeType = ECodeType.ECompanyCode;
    } else if (type === 'deptcodea') {
      list = this.pageInfo.listDeptCodeA;
      title = '사업장 검색';
      codeType = ECodeType.EDeptCodeA;
    } else if (type === 'deptcodeb') {
      list = this.pageInfo.listDeptCodeB;
      title = '부서 검색';
      codeType = ECodeType.EDeptCodeB;
    } else if (type === 'dutycodea') {
      list = this.pageInfo.listDutyCodeA;
      title = '직급 검색';
      codeType = ECodeType.EDutyCodeA;
    }
    this.codeDialogState.items = list;
    this.codeDialogState.show = true;
    this.codeDialogState.title = title;
    this.codeDialogState.codeType = codeType;
    this.codeDialogState.callback = this.CodeSelect;
  }

  async ClickSave() {
    const {
      name,
      empno,
      userStatus,
      userType,
      companyCode,
      deptCodeA,
      deptCodeB,
      dutyCodeA,
      listDoor,
      listGroup,
      periodFrom,
      periodTo,
      telNo,
      email,
      uid
    } = this.state;

    const req: I.UserRegisterReq = {
      name,
      empno,
      userStatus,
      userType,
      companyCode,
      deptCodeA,
      deptCodeB,
      dutyCodeA,
      listGroup,
      listDoor,
      periodFrom,
      periodTo,
      isAntipass: false,
      isAdmin: false,
      isEscort: false,
      timeFrom: '',
      timeTo: '',
      telNo,
      email,
      userid: -1,
      uid
    };
    console.log('req:', req);
    if (!this.state.name) {
      await this.showErrorModal('오류', '이름를 입력 해주세요.');
      return;
    } else if (!this.state.uid) {
      await this.showErrorModal('오류', '카드번호를 입력 해주세요.');
      return;
    }
    // const req = {} as I.UserRegisterReq;
    req.listDoor = this.state.listDoor;
    const result = await this.API.call.user.register(req);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('알림', '저장되었습니다.');
      if (this.fileUpload.files && this.fileUpload.files.length > 0) {
        await this.SavePhoto(result.data.userid);
        this.OnClear();
        return result.data;
      } else {
        this.OnClear();
        return result.data;
      }
    }
  }

  async SavePhoto(userid: number) {
    if (!this.fileUpload.files) return;
    const formData = new FormData();
    const file = this.fileUpload.files[0];
    console.log(file);
    formData.append('file', file, file.name);
    formData.append('userid', userid.toString());
    this.API.call.user.photo(formData);
  }
}
